import React from "react";
import { Link, NavLink } from "react-router-dom";

export default function ServiceCard({ title, description, accent, sub }) {
  return (
    <div className="bg-white p-5 shadow-soft transition duration-300 hover:-translate-y-1 hover:shadow-glow">
      <div
        className={`absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r ${accent}`}
      />
      <div className="text-sm uppercase tracking-[0.18em] text-slate-500">
        {sub}
      </div>
      <div className="mt-3 text-2xl font-semibold text-slate-900">{title}</div>
      <p className="mt-4 text-sm leading-7 text-slate-600">{description}</p>
      <Link to="/contact" className="mt-6 text-sm font-semibold text-amber-800">
        Learn more →
      </Link>
    </div>
  );
}
